import axios from 'axios'

const DEBUG_SUCCEEDED = false

const API_ROOT = (staging_mode) => {
  if (process.env.NODE_ENV === 'production') {
    if (staging_mode.toString() === 'true') {
      return 'https://badgeheroes-staging.herokuapp.com/api/'
    }
    return 'https://badgeheroes.herokuapp.com/api/'
  }
  // return 'http://bh.com:3002/api/'
  // return 'http://localhost:3002/api/'
  return 'http://mispistachos.lvh.me:3001/api'
  // return 'https://badgeheroes.herokuapp.com/api/'
}

const API_SUCCEDED = (process.env.NODE_ENV !== 'production' && DEBUG_SUCCEEDED) ?
  ((r) => { debugger; return r }) : (r => r)

const API_ERROR = (process.env.NODE_ENV !== 'production') ?
  ((e) => { debugger; return e }) : (e => e)

class Api {

  constructor() { this.set_axios() }

  set_axios = ({ token = localStorage.getItem('access_token'),
               staging_mode = localStorage.getItem('staging_mode') } = {}) => {
    const headers = { 'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'api-version': 3 }
    if (token) {
      localStorage.setItem('access_token', token)
      headers['access-token'] = token
    }
    localStorage.setItem('staging_mode', staging_mode)
    this.axios = axios.create({
      baseURL: API_ROOT(staging_mode),
      // baseURL: 'https://badgeheroes.herokuapp.com/api/',
      timeout: 100000,
      headers,
    })
  }

  get = (url, params = {}, succeed = API_SUCCEDED, error = API_ERROR) =>
    this.axios.get(url, params).then(succeed).catch(error)

  post = (url, params = {}, succeed = API_SUCCEDED, error = API_ERROR) => this.axios.post(url, params).then(succeed).catch(error)

  put = (url, params = {}, succeed = API_SUCCEDED, error = API_ERROR) =>
    this.axios.put(url, params).then(succeed).catch(error)

/* Campaigns*/
  loadCampaigns = () => this.get('/campaigns')
  selectCampaign = ({ id }) => this.get(`/campaigns/${id}`)

/* Missions*/
  missionHistory = ({ id }) => this.get(`/missions/${id}/answers`)
  preSelectMission = ({ id }) => this.get(`/missions/${id}`)
  missionInfo = ({ id }) => this.get(`/missions/${id}/info`)
  acceptMission = ({ id }) => this.post(`/missions/${id}/accept`)
  reviewMission = ({ missionId, answerId }) => this.get(`/missions/${missionId}/answers/${answerId}`)
  finishMission = params => this.post(`/missions/${params.id}/finish`, params)

/* User*/
  loginUser = ({ email, password }) => {
    localStorage.removeItem('access_token')
    this.set_axios({ token: false })
    return this.post('/log_in', { email, password },
    (r) => {
      this.set_axios({
        token: r.data.access_token,
        staging_mode: r.data.staging_mode,
      })
      return r
    })
  }

  preLoginUser = ({ email }) => this.get(`/pre_login?email=${email}`,
    (r) => {
      this.set_axios({
        token: r.data.access_token,
        staging_mode: r.data.staging_mode,
      })
      return r
    })

  logoutUser = () => {
    localStorage.removeItem('access_token')
    this.set_axios({ staging_mode: false })
    return { data: true }
  }
  updateProfile = params => this.put(`/users/${params.id}`, params)
  fetchUserInfo = ({ id }) => this.get(`/users/${id}`)
  recoveryPassword = ({ email }) => this.post('/recover_password', { email })
  updateDevice = (params, user_id) => this.post(`/users/${user_id}/update_device`, params)
  userNotFound = params => this.post('/users/not_found', params)
  contact = params => this.post('contact', params)
  firebase_token = callback => this.get('users/firebase_token', {}, callback)
  new_events = () => this.get('users/new_events')

/* Prizes*/
  fetchPrizes = ({ id }) => this.get('/prizes', { id })
  fetchOwnPrizes = () => this.get('/prizes/my_prizes')
  buyPrize = ({ id }) => this.post(`/prizes/${id}/redeem`)

/* Activity*/
  fetchPeopleLog = () => this.get('/logs/people')

/* S3 */
  getS3Url = file_name => this.post('/users/s3_signed_url', { file_name })

/* Settings */
  settings = () => this.get('/clients/settings')

}

const api = new Api()

export default api



// WEBPACK FOOTER //
// ./src/middleware/api.jsx